import '../../css/supervisorcontrolls/supervisormenu.css';
import React, { useRef, useState, useEffect } from 'react';
import themes from "devextreme/ui/themes";
import { connect } from 'react-redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import ChangePassword from './changePassword';
import { useNavigate } from "react-router-dom";
import useMonitorAPIService from '../../services/monitorapiservice';
import Config from '../misc/config';
import Alarms from '../misc/alarms';
import { resetLayout, emptyLayout } from 'src/redux/supervisorSlice';
import Toastr from '../utils/toastr';
import CorporateGroupsModal from '../misc/corporateGroupsModal';
function SupervisorMenu(props) {

    const wrapperRef = useRef(null);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { logout, saveLayout } = useMonitorAPIService();
    const [theme, setTheme] = useState(localStorage.getItem("faTheme"));
    const [showChangePassword, setShowChangePassword] = useState(localStorage.getItem("faChangePwd") === "true");
    const [showConfig, setShowConfig] = useState(false);
    const [showAlarms, setShowAlarms] = useState(false);
    const [showCorpoGrps, setShowCorpoGrps] = useState(false);
    const toastrRef = useRef(null);

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (props.showSettings && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                props.toggleSettings();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        //UNMOUNT
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [props]);

    const changeTheme = e => {
        if (e)
            e.preventDefault();
        let newTheme = theme === "light" ? "dark" : "light";
        localStorage.setItem("faTheme", newTheme);
        setTheme(newTheme);
        let html = document.getElementsByTagName("html")[0];
        html.setAttribute("data-theme", newTheme);
        themes.current(`generic.${newTheme}.compact`);
    };

    const toggleChangePasswordModal = e => {
        if (e)
            e.preventDefault();

        setShowChangePassword(!showChangePassword);
        props.toggleSettings(false);
    };

    const toggleConfig = e => {
        if (e)
            e.preventDefault();

        setShowConfig(!showConfig);
        props.toggleSettings(false);
    };

    const toggleAlarms = e => {
        if (e)
            e.preventDefault();

        setShowAlarms(!showAlarms);
        props.toggleSettings(false);
    }

    const closeSession = (e) => {
        e.preventDefault();

        logout(props.token, res => {

            localStorage.removeItem("id");
            localStorage.removeItem("token");
            navigate("/login");
            window.location.reload();
        });
    };

    const resetLayout = e => {
        e.preventDefault();
        props.emptyLayout();

        setTimeout(() => {
            props.resetLayout();
        }, 1);
    };

    const saveUserLayout = e => {
        e.preventDefault();
        let userLayout = {};
        let keys = Object.keys(localStorage).filter(x => x.endsWith(`user${props.id}`));
        keys.forEach(v => { userLayout[v] = localStorage.getItem(v) });
        saveLayout(props.token, userLayout, res => {

            if (res.data && res.data === true) {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
            }
            props.toggleSettings(false);
            toastrRef.current.show();
        });
    };
    const toggleCorpoGrps = e => {
        if (e)
            e.preventDefault();

        setShowCorpoGrps(!showCorpoGrps);
        props.toggleSettings(false);
    }
    return (
        <>
            <div ref={wrapperRef} className={"menu-user menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-275px " + (props.showSettings ? "show" : "")} >

                <div className="menu-item px-3">
                    <div className="menu-content d-flex align-items-center px-3">

                        <div className="symbol symbol-50px me-5">
                            {
                                (!props.image) &&
                                <div className='user-img text-primary bg-light-primary'>{props.initials}</div>
                            }

                            {
                                (props.image) &&
                                <img src={`//${props.image}`} alt="profile" />
                            }
                        </div>
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center fs-5">{props.name}</div>
                            <div className="text-muted fs-7">{props.fullname}</div>
                        </div>


                    </div>
                </div>


                <div className="separator my-2"></div>
                <div className="menu-item px-5">
                    {
                        (theme === "light") &&
                        <a href='/' onClick={changeTheme} className="menu-link px-5">
                            <FontAwesomeIcon size='lg' icon={duotone("moon-stars")} />
                            <span className="px-2">{t("darkmode")}</span>
                        </a>
                    }
                    {
                        (theme === "dark") &&
                        <a href='/' onClick={changeTheme} className="menu-link px-5">
                            <FontAwesomeIcon size='lg' icon={duotone("sun")} />
                            <span className="px-2">{t("lightmode")}</span>
                        </a>
                    }
                </div>
                <div className="separator my-2"></div>
                <div className="menu-item px-5">
                    <a href='/' onClick={toggleConfig} className="menu-link px-5">
                        <FontAwesomeIcon size='lg' icon={duotone("cog")} />
                        <span className="px-2">{t("config")}</span>
                    </a>
                </div>
                <div className="menu-item px-5">
                    <a href='/' onClick={toggleAlarms} className="menu-link px-5">
                        <FontAwesomeIcon size='lg' icon={duotone("bell")} />
                        <span className="px-2">{t("alarms")}</span>
                    </a>
                </div>
                {
                    props.functions.corporativeGroups &&
                    <div className="menu-item px-5">
                        <a href='/' onClick={toggleCorpoGrps} className="menu-link px-5">
                            <FontAwesomeIcon size='lg' icon={duotone("user-group")} />
                            <span className="px-2">{t("corporategroups")}</span>
                        </a>
                    </div>
                }
                <div className="separator my-2"></div>
                <div className="menu-item px-5">
                    <a href='/' onClick={toggleChangePasswordModal} className="menu-link px-5">
                        <FontAwesomeIcon size='lg' icon={duotone("key")} />
                        <span className="px-2">{t("changepassword")}</span>
                    </a>
                </div>
                <div className="separator my-2"></div>
                <div className="menu-item px-5">
                    <a href='/' onClick={resetLayout} className="menu-link px-5">
                        <FontAwesomeIcon size='lg' icon={duotone("window-restore")} />
                        <span className="px-2">{t("defaultview")}</span>
                    </a>
                </div>
                <div className="menu-item px-5">
                    <a href='/' onClick={saveUserLayout} className="menu-link px-5">
                        <FontAwesomeIcon size='lg' icon={duotone("floppy-disk")} />
                        <span className="px-2">{t("saveview")}</span>
                    </a>
                </div>
                <div className="separator my-2"></div>

                <div className="menu-item px-5">
                    <a href='/' onClick={closeSession} className="menu-link px-5">
                        {/* <FontAwesomeIcon icon={duotone("door-open")} /> */}
                        <FontAwesomeIcon icon={duotone("person-from-portal")} />
                        <span className="px-2">{t("logout")}</span>
                    </a>
                </div>

            </div>
            <ChangePassword show={showChangePassword} toggleModal={toggleChangePasswordModal} userId={props.userId}></ChangePassword>
            <Config show={showConfig} toggleModal={toggleConfig} ></Config>
            <Alarms show={showAlarms} toggleModal={toggleAlarms} ></Alarms>
            <CorporateGroupsModal show={showCorpoGrps} toggleModal={toggleCorpoGrps} ></CorporateGroupsModal>
            <Toastr ref={toastrRef} />
            {/* 
            <SessionCosedNotification show={this.state.showSessionClosedModal} toggleModal={this.toggleSessionClosedModal} message={this.state.sessionClosedMessage} ></SessionCosedNotification> */}


        </>
    );
}

const mapStateToProps = (state) => {
    return {
        name: state.supervisor.name,
        fullname: state.supervisor.fullname,
        image: state.supervisor.image,
        initials: state.supervisor.initials,
        id: state.supervisor.id,
        token: state.supervisor.token,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, { resetLayout, emptyLayout })(SupervisorMenu);
